// extracted by mini-css-extract-plugin
export default {"content":"MainMenu_content__iPM1S"};